var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDd2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0667 3.4H1.73333V0.733337H23.0667V3.4ZM13.7333 16.0667C13.7333 17.5867 14.3067 19.2133 15.0667 20.7333V22.0667H1.73333V14.0667H0.400002V11.4L1.73333 4.73334H23.0667L24 9.4C23.0667 8.97334 22.1067 8.73334 21.0667 8.73334C17.0667 8.73334 13.7333 12.0667 13.7333 16.0667ZM12.4 14.0667H4.4V19.4H12.4V14.0667ZM25.7333 16.0667C25.7333 19.5333 21.0667 24.7333 21.0667 24.7333C21.0667 24.7333 16.4 19.5333 16.4 16.0667C16.4 13.5333 18.5333 11.4 21.0667 11.4C23.6 11.4 25.7333 13.5333 25.7333 16.0667ZM22.6667 16.2C22.6667 15.4 21.8667 14.6 21.0667 14.6C20.2667 14.6 19.4667 15.2667 19.4667 16.2C19.4667 17 20.1333 17.8 21.0667 17.8C22 17.8 22.8 17 22.6667 16.2Z",
    fill: "#A9CF4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDd2);
export default __webpack_public_path__ + "static/media/dd-2.e9ede5d1b631e96876679c4496af9765.svg";
export { ForwardRef as ReactComponent };